import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { ButtonWithIcon } from '@els/els-react--button';
import SelectWrapper from '@Components/Popup/SelectWrapper';
import SelectToggler from '@Components/Popup/SelectWrapper/SelectToggler';
import { List } from 'immutable';
import AvailableResultsList from '../AvailableResultsList';
import CurrentAvailableResult from './CurrentAvailableResult';

import './ResultsFrom.scss';

export function createAvailableResultsList(id, results, selectResultOfAlert, disabled) {
  if (disabled) {
    return () => null;
  }

  function AvailableResultsListWrapper(wrapperProps) {
    return <AvailableResultsList id={id} results={results} selectResultOfAlert={selectResultOfAlert} wrapperProps={wrapperProps} />;
  }

  return AvailableResultsListWrapper;
}

export function createToggler(selectedResultDate, selectedResultHits, disabled) {
  const resultText = <CurrentAvailableResult selectedResultDate={selectedResultDate} selectedResultHits={selectedResultHits} />;

  if (disabled) {
    function DisabledToggler() {
      return (
        <SelectToggler isOpen={false} onClick={noop} disabled={disabled} className="select-toggler-secondary results-from--select-toggler">
          {resultText}
        </SelectToggler>
      );
    }

    return DisabledToggler;
  }

  function TogglerWrapper(wrapperProps) {
    const { toggle, isOpen } = wrapperProps;

    return (
      <SelectToggler isOpen={isOpen} onClick={toggle} disabled={disabled} className="select-toggler-secondary results-from--select-toggler">
        {resultText}
      </SelectToggler>
    );
  }

  return TogglerWrapper;
}

export default function ResultsFrom({
  results,
  className,
  id,
  alert,
  fetchResultsInfo,
  selectResultOfAlert,
  selectedRunId,
  selectedResultDate,
  selectedResultHits,
}) {
  const disabled = results?.size === 0 || !selectedRunId;

  return (
    <>
      <section className={classnames('results-from', className)}>
        <span className="results-from--text">Results from:</span>

        <SelectWrapper
          disabled={disabled}
          className="results-from--select-wrapper"
          contentWrapperClassName="results-from--select-wrapper-content"
          content={createAvailableResultsList(id, results, selectResultOfAlert, disabled)}
          size="sm">
          {createToggler(selectedResultDate, selectedResultHits, disabled)}
        </SelectWrapper>
      </section>
      <ButtonWithIcon
        data-e2e={`alert-go-to-results-button-${id}`}
        className={`alert-right-block--go-button e2e-alert-go-${id}`}
        type="primary"
        sprite="ChevronRight"
        size="small"
        iconOnly
        disabled={disabled}
        onClick={() => {
          fetchResultsInfo(alert, selectedRunId);
        }}>
        Go to results
      </ButtonWithIcon>
    </>
  );
}

ResultsFrom.propTypes = {
  id: PropTypes.string,
  results: PropTypes.instanceOf(List),
  className: PropTypes.string,
  alert: PropTypes.object,
  fetchResultsInfo: PropTypes.func,
  selectResultOfAlert: PropTypes.func,
};
